// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"3dc27902","903":"1eb09cfc"}[chunkId] + ".chunk.js";
};